import { Input } from "@/components/shadcn/input";
import { cn } from "cn";
import type { LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";
import { FieldPath, FieldValues } from "react-hook-form";
import { FormFieldBase, FormFieldCommonProps } from "./form-field-base";

type TextInputFormFieldProps<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = FormFieldCommonProps<TFieldValues, TName> & {
    placeholder?: string;
    autoComplete?: ComponentProps<typeof Input>["autoComplete"];
    leadingIcon?: LucideIcon;
    className?: string;
};

export function TextInputFormField<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
    placeholder,
    autoComplete,
    leadingIcon: LeadingIcon,
    className,
    ...props
}: TextInputFormFieldProps<TFieldValues, TName>) {
    return (
        <FormFieldBase
            {...props}
            renderField={(field, fieldState, disabled) => (
                <div className="relative">
                    {LeadingIcon && (
                        <LeadingIcon
                            aria-hidden="true"
                            className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2"
                        />
                    )}
                    <Input
                        id={field.name}
                        type="text"
                        placeholder={placeholder}
                        autoComplete={autoComplete}
                        aria-invalid={fieldState.invalid}
                        disabled={disabled}
                        className={cn(LeadingIcon && "pl-9", className)}
                        {...field}
                    />
                </div>
            )}
        />
    );
}
